import { FolderOpen } from "lucide-react";

export default function SubClientsTab({ subclients }) {
  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      <div className="bg-white rounded-2xl shadow-sm border border-stone-200 overflow-hidden">
        <div className="p-6 border-b border-stone-100 bg-stone-50/50">
          <h2 className="text-xl font-semibold flex items-center gap-2 text-stone-800">
            <FolderOpen size={22} className="text-blue-500" /> Équipes (
            {subclients.length})
          </h2>
        </div>
        {subclients.length === 0 ? (
          <div className="p-12 text-center text-stone-500">
            <div className="size-16 bg-stone-100 text-stone-400 rounded-full flex items-center justify-center mx-auto mb-4">
              <FolderOpen size={32} />
            </div>
            <p className="text-lg font-medium text-stone-700 mb-1">
              Aucune équipe configurée
            </p>
            <p className="text-sm">
              Veuillez contacter l'administrateur pour créer des équipes.
            </p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-stone-50 border-b border-stone-200 text-xs uppercase tracking-wider text-stone-500 font-semibold">
                  <th className="px-6 py-4">Nom</th>
                  <th className="px-6 py-4">Identifiant (Slug)</th>
                  <th className="px-6 py-4">Documents accessibles</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-stone-100">
                {subclients.map((s) => (
                  <tr
                    key={s.id}
                    className="hover:bg-stone-50/80 transition-colors"
                  >
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div className="size-10 rounded-lg bg-blue-50 text-blue-500 flex items-center justify-center shrink-0">
                          <FolderOpen size={20} />
                        </div>
                        <span className="font-medium text-stone-800">
                          {s.name}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-mono font-medium bg-stone-100 text-stone-600 border border-stone-200">
                        {s.slug}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <span className="text-lg font-semibold text-stone-700">
                          {s.documents_count}
                        </span>
                        <span className="text-sm text-stone-400">fichiers</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
